module.exports = __webpack_public_path__ + "static/media/arrowLeftFirstItem.f8bb7a83.svg";